import { atomWithStorage } from "jotai/utils";

export type SessionState = {
	isAuthenticated: boolean;
	token: string;
	tokenVerify: string;
	authorizationType?: string;
};

const defaultState: SessionState = {
	isAuthenticated: false,
	token: "",
	tokenVerify: "",
};

export const sessionState = atomWithStorage<SessionState>(
	"MYPLANN_SESSION_STATE",
	defaultState,
);
